<script>
import lazyLoadComponent from '@router/lazyload-component'

export default {
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},

  methods: {},
}
</script>

<template>
  <div class="tutorial">
    <div class="tutorial__row">
      <div class="tutorial__item" style="width:100%">
        <div class="tutorial__title" style="min-height:auto;padding-left:0">
        
         直接複製瀏覽器上方網址，於後台【商店設定/Facebook粉絲專頁網址】欄位中貼上即可。
        </div>
        <img src="~@assets/images/tutorial/fbUrl.jpg" alt="" />
      </div>
     
     
    </div>
  </div>
</template>
<style lang="scss" module>
</style>
